export enum SettingMode {
  GENERAL_INFO = "GENERAL_INFO",
  USERS = "USERS",
}
